import React from "react";
import "./styles.scss";
import { ProductTypes } from "../../../modules/product-selection/constants/product-types";

const Index = ({ option, text, ItemUrl, categoryCode }) => {
  const picIconClass = () => {
    if (categoryCode === ProductTypes.SAVINGS_ACCOUNTS_ID) {
      return "w-50";
    }
    if (categoryCode === ProductTypes.CREDIT_CARD_ID) {
      return "w-120";
    }
    return "";
  };

  return (
    <>
      <div className={`pic__wrapper ${option}`}>
        <div className={"pic_icon-wrapper"}>
          <img
            className={`flag animate__animated animate__fadeIn pic_icon-wrapper-img ${picIconClass()}`}
            src={ItemUrl}
            alt="NTB online banking"
          />
        </div>
        <div className={"pic_icon-text"}>{text}</div>
      </div>
    </>
  );
};
export default Index;
